import { render } from "./moudleImg.vue?vue&type=template&id=fc115a2c&scoped=true"
import script from "./moudleImg.vue?vue&type=script&lang=js"
export * from "./moudleImg.vue?vue&type=script&lang=js"

import "./moudleImg.vue?vue&type=style&index=0&id=fc115a2c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc115a2c"]])

export default __exports__